import { render, staticRenderFns } from "./print-flow.vue?vue&type=template&id=2b692268&scoped=true&"
import script from "./print-flow.vue?vue&type=script&lang=js&"
export * from "./print-flow.vue?vue&type=script&lang=js&"
import style0 from "./print-flow.vue?vue&type=style&index=0&id=2b692268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b692268",
  null
  
)

export default component.exports